export default class SizeUtils {
    keyMirror = {
        // вроде дубликат
        // "neckAround": {
        //     "mirror": "neckAround",
        //     "displayName": "Обхват шеи",
        //     "help": "",
        //     "placeholder": "см"
        // },
        "neck": {
            "mirror": "neckAround",
            "displayName": "Обхват шеи",
            "help": "Измерение проводится по основанию шеи, где проходит линия воротника. Оберните сантиметровую ленту вокруг шеи над седьмым шейным позвонком, проходя по бокам шеи и замыкая ее спереди над яремной впадиной. Это будет как раз под вашим Адамовым яблоком. Сантиметровая лента должна слегка прилегать к коже, не сдавливая ее.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/GYVw1ovjxSU"
        },
        "chest": {
            "mirror": "chestAround",
            "displayName": "Обхват груди",
            "help": "Измерение проводится вокруг туловища по самой широкой части спины и груди. Сантиметровая лента проходит параллельно полу по выступающим точкам туловища. Сперва, попросите измеряемого поднять руки в стороны, чтобы вы могли обернуть ленту со спины на уровне лопаток, а затем опустить руки вниз, и замкнуть ленту спереди на груди на уровне сосков. Сантиметровая лента должна плотно проходить под мышками и над лопатками. Убедитесь, что лента не упала вниз по спине и плотно прилегает к телу.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/GVWzzTE555c"
        },
        "waist": {
            "mirror": "waistAround",
            "displayName": "Обхват талии",
            "help": "Измерение проводится вокруг туловища по самой узкой части. Оберните сантиметровую ленту горизонтально вокруг туловища на уровне талии, по самой узкой части. Пусть ваши руки свисают вниз в расслабленной, естественной позе. Сантиметровая лента проходит параллельно полу. Если у вас живот, оберните лентой наиболее полную часть живота, обычно это на уровне пупка. Измерительная лента должна плотно прилегать к телу, но не сдавливать его.",
            "placeholder": "см",
            "url": "https:/www.youtube.com/embed/MPvSenfAoQU"
        },
        "seat": {
            "mirror": "seatAround",
            "displayName": "Обхват бедер",
            "help": "Измерение проводится вокруг бедер по самой широкой части. Оберните сантиметровую ленту параллельно полу, по самой широкой части бедер и выступающим точкам ягодиц. Пусть ваши руки свисают вниз в расслабленной, естественной позе. Измерительная лента должна плотно прилегать к телу, но не сдавливать его.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/0LStsx4l2ow"
        },
        // todo удалить бицепсы после утверждения
        "biceps": {
            "mirror": "bicepsAround",
            "displayName": "Обхват бицепса",
            "help": "Оберните лентой бицепс в его самом широком месте. При измерении лента должна плотно (но без натяжения) прилегать к телу. Рука должна находиться в расслабленном состоянии. Примеры на фотографиях показывают обхват бицепса, равный 34 сантиметрам.",
            "placeholder": "см"
        },
        "chest_width": {
            "mirror": "chestWidth",
            "displayName": "Ширина груди",
            "help": "Измерение проводится горизонтально по груди между передними углами подмышечных впадин. Сперва попросите измеряемого встать прямо, в комфортной естественной позе. Пусть ваши руки свисают вниз в расслабленной позе. Определите передние углы подмышечных впадин на ощупь через одежду, либо зрительно, это будет точка соединения руки и груди. Приложите сантиметровую ленту горизонтально от одного угла подмышки к другому и запишите получившиеся число.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/-pN8TaKRqUk"
        },
        "back_width": {
            "mirror": "backWidth",
            "displayName": "Ширина спины",
            "help": "Измерение проводится горизонтально по груди между задними углами подмышечных впадин. Сперва попросите измеряемого встать прямо, в комфортной естественной позе. Пусть ваши руки свисают вниз в расслабленной позе. Определите задние углы подмышечных впадин на ощупь через одежду, либо зрительно, это будет точка соединения руки и спины. Приложите сантиметровую ленту горизонтально от одного угла подмышки к другому и запишите получившиеся число.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/zkbaOZgS62E"
        },
        "shirt_length": {
            "mirror": "shirtLength",
            "displayName": "Длина изделия",
            "help": "Измерение проводится от 7-го шейного позвонка до желаемой длины сорочки. Поместите один край измерительной ленты у задней части основания шеи и измерьте вниз вдоль спины до точки, где вы хотите, чтобы заканчивалась рубашка. Обычно эта точка находится внизу ягодиц, хотя вы можете сделать длину немного длиннее. Если планируете носить сорочка под заправку, то длина должна доходить до подъягодичной складки, а если навыпуск, как правило, длина на пару сантиметров выше, но не ниже выступающих точек ягодиц.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/L2INRodO6aI"
        },
        "shoulder_width": {
            "mirror": "shoulderWidth",
            "displayName": "Ширина плеча",
            "help": "Измерение проводится по правому плечу, от точки основания шеи до выступающей плечевой косточки. Сперва, попросите измеряемого встать прямо, пусть руки свисают вниз в расслабленной, естественной позе. Определить конечную плечевую точку может быть немного сложно, ориентируйтесь на выступающую косточку в месте где плечо изгибается и переходит в руку. Приложите сантиметровую ленту от точки основания шеи вдоль плеча до конечной плечевой точки. Или наденьте любимую сорочку и замерьте расстояние плечевого шва от воротника вдоль плеча до точки соединения с рукавом.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/4CiidZMvz9Y"
        },
        "arm_length": {
            "mirror": "sleeveLength",
            "displayName": "Длина рукава",
            "help": "Измерение проводится от точки основания шеи через выступающую плечевую косточку и далее вниз по руке. Данное измерение является продолжением мерки “Ширины плеча”. Сначала попросите измеряемого встать прямо, с расслабленными руками вдоль тела, взгляд прямо перед собой. Приложите сантиметровую ленту от точки основания шеи, вдоль плеча через конечную плечевую точку, придерживая ленту в этом месте, чтобы она не упала, и далее вниз по руке до точки, где, по Вашему желанию, должен заканчиваться рукав. Как правило, это начало мясистой части тыльной стороны ладони, косточка большого пальца.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/-403bvRGhqA"
        },
        "short_sleeve_length": {
            "mirror": "shortSleeveLength",
            "displayName": "Длина кор. рукава",
            "help": "Измерение проводится от точки основания шеи через выступающую плечевую косточку и далее вниз по руке. Данное измерение является продолжением мерки “Ширины плеча”. Сначала попросите измеряемого встать прямо, с расслабленными руками вдоль тела, взгляд прямо перед собой. Приложите сантиметровую ленту от точки основания шеи, вдоль плеча через конечную плечевую точку, придерживая ленту в этом месте, чтобы она не упала, и далее вниз по руке до точки, где, по Вашему желанию, должен заканчиваться короткий рукав.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/d25-pXj6luI"
        },
        "shoulder": {
            "mirror": "shoulderAround",
            "displayName": "Обхват плеча",
            "help": "Измерение проводится вокруг верхней части бицепса, прямо под подмышкой. Встаньте прямо с расслабленными руками вдоль тела. Оберните сантиметровой лентой бицепс в его наиболее широком месте. Убедитесь, что сантиметровая лента не слишком туго сжимает руку. Округлите число до десятых.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/yej3E-BNX_Q"
        },
        "elbow": {
            "mirror": "elbowAround",
            "displayName": "Обхват локтя",
            "help": "Измерение проводится по слегка согнутой руке. Оберните сантиметровую ленту вокруг выступающего локтевого сустава и замкните ее на внутренней части сгиба локтя.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/Sw88wrO_AI8"
        },
        "wrist": {
            "mirror": "wristAround",
            "displayName": "Обхват запястья",
            "help": "Для измерения обхвата запястья оберните сантиметровую ленту вокруг лучезапястного сустава кисти.  Держите сантиметровую ленту плотно к коже, но не сжимайте запястье. Округлите число до десятых.",
            "placeholder": "см",
            "url": "https://www.youtube.com/embed/bgt4xolQsGE"
        },
        "height": {
            "mirror": "height",
            "displayName": "Рост",
            "help": "",
            "placeholder": "см",
            "url": ""
        },
        "sizeHeight": {
            "mirror": "sizeHeight",
            "displayName": "Рост",
            "help": "",
            "placeholder": "см"
        },
        "sizeWeight": {
            "mirror": "sizeWeight",
            "displayName": "Вес",
            "help": "",
            "placeholder": "кг"
        },
        "sizeCollar": {
            "mirror": "sizeCollar",
            "displayName": "Обхват шеи",
            "help": "",
            "placeholder": "см"
        },
        "displayName": {
            "mirror": "displayName",
            "displayName": "Ворот",
            "help": "",
            "placeholder": "см"
        },
    };

    individualSizes = {
        neckAround: 0,
        chestAround: 0,
        waistAround: 0,
        seatAround: 0,
        bicepsAround: 0,
        wristAround: 0,
        sleeveLength: 0,
        shortSleeveLength: 0,
        shirtLength: 0,
        height: 0,
        shoulderType: 'shoulderNormal',
        shoulderWidth: 0,
        backWidth: 0,
        chestWidth: 0,
        displayName: ''
    }

    getMirriored(properties) {
        const keyMirrors = this.keyMirror
        const mirrored = Object.keys(properties).reduce((acc, key) => {
            if (keyMirrors[key]) {
                return { ...acc, [keyMirrors[key].mirror]: properties[key] }
            }
            return acc;
        }, {})
        return mirrored
    };

}